import { Link } from 'react-router-dom';
import { ArrowDown, ArrowRight } from 'lucide-react';
import { ServiceCard } from '../components/ServiceCard';

export default function HomePage() {
  return (
    <main data-testid="home-page">
      {/* Hero Section */}
      <section className="min-h-screen flex flex-col justify-center relative pt-20" data-testid="hero-section">
        <div className="page-container">
          <div className="max-w-4xl">
            <span className="label-mono mb-6 block animate-fade-up">
              Acompanhamento Cognitivo
            </span>
            
            <h1 className="heading-display mb-8 animate-fade-up delay-100">
              Clareza para pensar.<br />
              Estrutura para decidir.
            </h1>
            
            <p className="body-text max-w-2xl animate-fade-up delay-200 !mb-[48px] !mr-[190px]">Diferentes níveis de envolvimento para diferentes momentos de vida.

O que muda é a profundidade do trabalho.
            </p>

            {/* Progression Visual */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-8 mb-12 animate-fade-up delay-300">
              <div className="flex items-center gap-3">
                <span className="font-mono text-sm text-[#5A5A5A]">01</span>
                <span className="font-serif text-xl">Coaching</span>
              </div>
              <ArrowRight className="hidden sm:block text-[#E6E4DC]" size={20} />
              <div className="flex items-center gap-3">
                <span className="font-mono text-sm text-[#5A5A5A]">02</span>
                <span className="font-serif text-xl">Estrutura</span>
              </div>
              <ArrowRight className="hidden sm:block text-[#E6E4DC]" size={20} />
              <div className="flex items-center gap-3">
                <span className="font-mono text-sm text-[#5A5A5A]">03</span>
                <span className="font-serif text-xl">Sistema</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 animate-fade-up delay-400">
              <Link to="/acompanhamentos" className="btn-primary" data-testid="cta-services">
                Ver Acompanhamentos
              </Link>
              <Link to="/contacto" className="btn-outline" data-testid="cta-contact">
                Iniciar Conversa
              </Link>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 hidden md:block">
          <ArrowDown className="text-[#E6E4DC] arrow-bounce" size={24} />
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="section section-muted" data-testid="philosophy-section">
        <div className="page-container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 items-start">
            <div>
              <span className="label-mono mb-4 block">Filosofia</span>
              <h2 className="heading-section mb-6">
                Trabalho de bastidor,<br />
                não de palco.
              </h2>
            </div>
            
            <div className="space-y-6">
              <p className="body-text">
                Não é sobre motivação ou promessas de transformação. 
                É sobre conversa orientada, análise cognitiva, 
                escrita estruturada e frameworks próprios.
              </p>
              <p className="body-text">
                O objetivo não é inspirar, mas clarificar. 
                Construir sistemas de decisão ajustados ao contexto 
                e à forma de pensar de cada pessoa.
              </p>
              <p className="body-text">
                Pensar e decidir são sempre responsabilidade de quem 
                está do outro lado. O meu papel é criar as condições 
                para que isso aconteça com maior clareza e estrutura.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section" data-testid="services-preview-section">
        <div className="page-container">
          <div className="mb-16">
            <span className="label-mono mb-4 block">Acompanhamentos</span>
            <h2 className="heading-section">
              Três níveis de envolvimento
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ServiceCard
              number="01"
              title="Orientação"
              subtitle="Coach & Orientador"
              description="Acompanhamento pontual para momentos de decisão ou clarificação específica."
              frequency="1–2 sessões por mês"
              href="/acompanhamentos#orientacao" />

            <ServiceCard
              number="02"
              title="Estrutura"
              subtitle="Analista & Facilitador Cognitivo"
              description="Acompanhamento contínuo para construção de hábitos de pensamento e organização."
              frequency="2 sessões por mês"
              href="/acompanhamentos#estrutura" />

            <ServiceCard
              number="03"
              title="Arquitetura"
              subtitle="Arquiteto Cognitivo"
              description="Acompanhamento continuado e estrutural para quem precisa de redesenhar a forma como pensa e decide."
              frequency="3–4 sessões por mês"
              href="/acompanhamentos#arquitetura" />

          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-muted" data-testid="cta-section">
        <div className="page-container">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="heading-section mb-6">
              Isto não é para toda a gente.
            </h2>
            <p className="body-text mb-8">
              Se chegou até aqui e reconhece a necessidade de um espaço de clareza 
              — não de motivação — o primeiro passo é uma conversa.
            </p>
            <Link to="/contacto" className="btn-primary" data-testid="cta-bottom">
              Iniciar Conversa
            </Link>
          </div>
        </div>
      </section>
    </main>);

}
